
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M501.028571 636.342857c-21.942857-87.771429-69.485714-171.885714-135.314285-234.057143-3.657143-3.657143-3.657143-10.971429 0-14.628571 3.657143-3.657143 7.314286-3.657143 10.971428-3.657143 43.885714 10.971429 87.771429 18.285714 135.314286 18.285714 47.542857 0 91.428571-7.314286 135.314286-18.285714 7.314286 0 10.971429 3.657143 14.628571 7.314286 0 3.657143 0 7.314286-3.657143 10.971428-65.828571 65.828571-113.371429 146.285714-135.314285 234.057143 0 7.314286-7.314286 10.971429-14.628572 7.314286-3.657143-3.657143-7.314286-3.657143-7.314286-7.314286z",
        "fill": "#FFCD00"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M449.828571 1024v-266.971429c-3.657143-153.6-84.114286-296.228571-215.771428-376.685714L3.657143 248.685714v438.857143c0 47.542857 25.6 91.428571 65.828571 117.028572l380.342857 219.428571z",
        "fill": "#88CC00"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M574.171429 1024v-266.971429c3.657143-153.6 84.114286-296.228571 215.771428-376.685714l230.4-131.657143v438.857143c0 47.542857-25.6 91.428571-65.828571 117.028572l-380.342857 219.428571z",
        "fill": "#0080FF"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M76.8 149.942857l219.428571 124.342857c135.314286 76.8 299.885714 76.8 435.2 0l215.771429-124.342857L559.542857 7.314286c-29.257143-10.971429-62.171429-10.971429-91.428571 0L76.8 149.942857z",
        "fill": "#FF6900"
      }
    }
  ]
})
    }
  